var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2927 4.84425L1.7037 0.258247C1.51329 0.0860865 1.26397 -0.0062595 1.00736 0.000329861C0.750745 0.00691922 0.506493 0.111939 0.325172 0.293645C0.143852 0.475351 0.0393515 0.719827 0.0333071 0.976454C0.0272628 1.23308 0.120137 1.48221 0.292702 1.67225L4.8787 6.25825C5.06617 6.44578 5.17149 6.70008 5.17149 6.96525C5.17149 7.23041 5.06617 7.48472 4.8787 7.67225L0.292702 12.2582C0.199857 12.3512 0.126222 12.4614 0.0760003 12.5828C0.0257783 12.7042 -4.63654e-05 12.8343 6.24903e-08 12.9656C4.64904e-05 13.0969 0.0259633 13.227 0.0762711 13.3483C0.126579 13.4697 0.200292 13.5799 0.293202 13.6727C0.386113 13.7656 0.496399 13.8392 0.617767 13.8894C0.739135 13.9397 0.869208 13.9655 1.00056 13.9654C1.1319 13.9654 1.26196 13.9395 1.38329 13.8892C1.50462 13.8389 1.61486 13.7652 1.7077 13.6722L6.2927 9.08625C6.85511 8.52366 7.17106 7.76074 7.17106 6.96525C7.17106 6.16975 6.85511 5.40683 6.2927 4.84425Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.58439f85eadf22f98d0f85af1db9442d.svg";
export { ForwardRef as ReactComponent };